import { render, staticRenderFns } from "./EditProfileContent.vue?vue&type=template&id=6c860520&scoped=true"
import script from "./EditProfileContent.vue?vue&type=script&lang=js"
export * from "./EditProfileContent.vue?vue&type=script&lang=js"
import style0 from "./EditProfileContent.vue?vue&type=style&index=0&id=6c860520&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c860520",
  null
  
)

export default component.exports